'use client';

import React from 'react';

interface PagerIndicatorProps {
  totalPages: number;
  currentPage: number;
  onPageChange?: (page: number) => void;
  className?: string;
}

const PagerIndicator: React.FC<PagerIndicatorProps> = ({
  totalPages,
  currentPage,
  onPageChange,
  className = ""
}) => {
  const handlePageClick = (page: number) => {
    if (onPageChange && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <div data-component-id="src/components/ui/PagerIndicator.tsx:25:4" data-component-path="src/components/ui/PagerIndicator.tsx" data-component-line="25" data-component-file="PagerIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex flex-row gap-x-[9px] ${className}`}>
      {Array.from({ length: totalPages }, (_, index) => {
        const page = index + 1;
        const isActive = page === currentPage;
        
        return (
          <div data-component-id="src/components/ui/PagerIndicator.tsx:31:10" data-component-path="src/components/ui/PagerIndicator.tsx" data-component-line="31" data-component-file="PagerIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
            key={page}
            onClick={() => handlePageClick(page)}
            className={`
              w-[21px] h-[21px] rounded-[10px] cursor-pointer transition-colors duration-150
              ${isActive ? 'bg-global-1' : 'bg-global-10'}
            `}
          />
        );
      })}
    </div>
  );
};

export default PagerIndicator;